import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetch as fetchAction, success, error } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchUserToModifyActionPayload = ReturnType<typeof fetchAction>;

function* fetchUserToModifySaga({ meta }: FetchUserToModifyActionPayload) {
  const { getUserInfo } = getAPI();
  const response: YieldOf<typeof getUserInfo> = yield call(getUserInfo, meta.login);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(success(data));
  } else {
    const requestError = problem || 'unknown';
    yield put(error(requestError));
  }
}

export default function* userInfoToModifySaga() {
  yield takeLatest(fetchAction.type, fetchUserToModifySaga);
}
